import React from "react";
import { Tag } from "antd";
import DataTable from "../../../components/DataTable";

const actionSeverityMap = {
  LOGIN: { color: "success" },
  MODULE_START: { color: "success" },
  MODULE_STOP: { color: "warning" },
  MODULE_DELETE: { color: "error" },
  ADD_USER: { color: "processing" },
  UPDATE_USER: { color: "warning" },
  DELETE_USER: { color: "error" },
  PROJECT_CREATE: { color: "processing" },
  PROJECT_UPDATE: { color: "warning" },
  PROJECT_DELETE: { color: "error" },
};

const targetColorMap = {
  AUTH: "#6c757d",
  SKEYEFORM: "#0d6efd",
  SKEYECUBE: "#0d6efd",
  SKEYECHART: "#0d6efd",
  SKEYENOTE: "#0d6efd",
  SKEYEINGEST: "#0d6efd",
  SKEYPREDICT: "#0d6efd",
  HADOOP: "#198754",
  SPARK: "#198754",
  HIVE: "#198754",
  DGHELPER: "#ffc107",
  FAHRAS: "#ffc107",
  JEYEDA: "#ffc107",
};

export default function ActivityLogsTable({ data, loading }) {
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: "60px",
      sorter: (a, b) => (a.id || 0) - (b.id || 0),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      sorter: (a, b) => (a.action || "").localeCompare(b.action || ""),
      render: (action) => {
        const c = actionSeverityMap[action] || { color: "default" };
        return <Tag color={c.color}>{action}</Tag>;
      },
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target",
      sorter: (a, b) => (a.target || "").localeCompare(b.target || ""),
      render: (target) => (
        <Tag color={targetColorMap[target] || "#aaa"}>{target}</Tag>
      ),
    },
    { title: "Details", dataIndex: "details", key: "details" },
    {
      title: "Client IP",
      dataIndex: "clientIp",
      key: "clientIp",
      width: "140px",
      render: (ip) => ip || <span style={{ color: "#999" }}>N/A</span>,
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      sorter: (a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
      render: (ts) => (
        <span style={{ fontSize: "0.85rem" }}>
          {new Date(ts).toLocaleString()}
        </span>
      ),
    },
  ];

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      pageSizeOptions={[10, 25, 50, 100]}
      defaultPageSize={25}
    />
  );
}
